module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "opera-account"
  }, [_c('topNav', {
    attrs: {
      "title": _vm.$t('account_title'),
      "url": "/opera/setting"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "perInfo"
  }, [_c('mt-cell', {
    attrs: {
      "title": _vm.$t('code'),
      "value": _vm.perInfo.code
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": _vm.$t('hotelGroupName'),
      "value": _vm.perInfo.hotelGroupName
    }
  }), _vm._v(" "), _c('mt-cell', {
    staticClass: "split",
    attrs: {
      "title": _vm.$t('hotelName'),
      "value": _vm.perInfo.hotelName
    }
  }), _vm._v(" "), _c('mt-cell', {
    staticClass: "split topcell",
    attrs: {
      "title": _vm.$t('account_lockerTip'),
      "label": _vm.$t('account_lockerTip_label'),
      "value": _vm.lockerTip,
      "is-link": "",
      "to": "/opera/accountLocker"
    }
  }), _vm._v(" "), _c('mt-cell', {
    staticClass: "topcell",
    attrs: {
      "title": _vm.$t('lastLoginDate'),
      "value": _vm.perInfo.lastLoginDate
    }
  }), _vm._v(" "), _c('mt-cell', {
    staticClass: "split",
    attrs: {
      "title": _vm.$t('lastIp'),
      "value": _vm.perInfo.lastIp
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v(_vm._s(_vm.$t('account_tip')))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-b41cb18a","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/operaPage/account.vue
// module id = 1832
// module chunks = 107